module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/addclienttrade/addclienttrade.component.css
// module id = ./src/app/addclienttrade/addclienttrade.component.css
// module chunks = main